module.exports = __webpack_public_path__ + "img/js-banner-3.7999e55b.png";